import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { FlexCol, FlexRow } from '@/components/ui/flex';
import { Text } from '@/components/ui/text';
import { type FC } from 'react';

export const ConfirmationModal: FC<{
  numItems: number;
  databaseSourceName: string;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (mode: 'append' | 'overwrite') => void;
}> = ({ numItems, databaseSourceName, isOpen, onOpenChange, onConfirm }) => {
  const handleConfirm = (mode: 'append' | 'overwrite') => {
    onOpenChange(false);
    onConfirm(mode);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Add rows or overwrite existing rows?</DialogTitle>
        </DialogHeader>
        <FlexCol gap="2">
          <Text variant="body-sm" color="primary">
            You have data in your current table. You can either:
          </Text>
          <Text variant="body-sm" color="primary">
            <ul className="list-disc list-inside">
              <li>Add new items: Keep existing data and add new items.</li>
              <li>
                Overwrite existing items: Overwrite {numItems} items from{' '}
                {databaseSourceName} with the new items.
              </li>
            </ul>
          </Text>
        </FlexCol>
        <FlexRow gap="2">
          <Button
            type="button"
            variant="dark"
            onMouseDown={() => {
              handleConfirm('append');
            }}
          >
            Add new items
          </Button>
          <Button
            type="button"
            variant="destructive"
            onMouseDown={() => {
              handleConfirm('overwrite');
            }}
          >
            Overwrite existing items
          </Button>
        </FlexRow>
      </DialogContent>
    </Dialog>
  );
};
